import './index.scss';
import { useContext, useState } from 'react';
import { AiOutlineClose, AiOutlineCheck } from 'react-icons/ai';
import helpers from 'src/utils/helpers';
import { ScreenTitle, FlexRow, Button } from 'src/style';
import { Modal } from 'src/component/Modal';
import ApiContext from 'src/provider/API/call-service';
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import { Select } from 'src/component/Select';
import { commentType } from 'src/provider/config/constant';

export const CommentModal = () => {
    const { API } = useContext(ApiContext);
    const { visibility, setModal, notifier } = useContext(VisibilityContext);
    const [data, setData] = useState({ commentType: "", adminComment: "" });

    const handleCancel = () => {
        setModal({ key: "showCommentModal", value: false });
        setData({ commentType: "", adminComment: "" });
    };

    const handleSubmit = async () => {
        const validation = helpers.inputValidator(data);
        if (!validation.isValidated) return notifier.show(validation.message, 'Validation Response');
        const response = await API.addResultComment(data);
        if (response) {
            handleCancel();
        };
    };

    const handleSelect = (key: string, value: string) => {
        const newValue = value.split("'")[0];
        setData({ ...data, [key]: newValue });
    };

    return (
        <Modal
            className='comment-modal'
            open={visibility.showCommentModal}
            cancel={handleCancel}
        >
            <ScreenTitle
                color='#712126'
                textSize='2'
                bottomMargin='4'
            >
                Result Comment
            </ScreenTitle>
            <Select
                name='commentType'
                list={commentType}
                label='Comment Type'
                handleSelect={handleSelect}
                placeholder='Select comment type'
            />

            <label htmlFor="comment">Comment</label>
            <textarea
                rows={5}
                id='comment'
                onChange={(e) => setData({...data, adminComment: e.target.value})}
                value={data.adminComment}
                placeholder='Comment on result'
            />

            <FlexRow isMaxWidth>
                <FlexRow topMargin='2' justifyContent='space-between' className='btn-container'>
                    <Button
                        hoverColor='#A77B37'
                        onClick={handleCancel}
                        className='add-comment-btn cancel'
                    >
                        <AiOutlineClose size={17} />
                        Cancel
                    </Button>
                    <Button
                        hoverBgColor='#fff'
                        hoverColor='#A77B37'
                        borderColor='#A77B37'
                        onClick={handleSubmit}
                        className='add-comment-btn confirm'
                    >
                        <AiOutlineCheck size={17} />
                        Confirm
                    </Button>
                </FlexRow>
            </FlexRow>
        </Modal>
    )
}
